import {useTranslation} from 'react-i18next'
export interface RefOutdatedMarker {character_id:string;reason:string;marked_at:number}
export function RefOutdatedNotice({markers}:{markers:RefOutdatedMarker[]}) {
 const {t}=useTranslation()
 if(!markers.length)return null
 return <div role="status" className="space-y-1 rounded-md border p-3 text-sm">
  <p className="font-medium">{t('refOutdated.title')}</p>
  {markers.map(m=><p key={m.character_id}>{m.character_id} · {t(m.reason.startsWith('ref_image_changed_legacy:')?'refOutdated.legacy':'refOutdated.exact')}</p>)}
 </div>
}
